export default __webpack_public_path__ + "static/media/mobile-order-bullet.dddb03cb.svg";